/**
=========================================================
* Soft UI Dashboard React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import React from "react";
import PropTypes from "prop-types";

// @mui material components
import { AccountCircle, Mail } from '@material-ui/icons';
import QuizIcon from '@mui/icons-material/Quiz';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import SoftBox from "../SoftBox";
import SoftTypography from "../SoftTypography";
import {
  Card
} from "@mui/material";
import CALENDAR from "../../assets/images/calendar.svg";
import MAIL from "../../assets/images/mail.svg"
import PHONECALL from "../../assets/images/phone-call.svg";

function Bill({ showCodeGenerated, name, email, phone, noGutter, status, completion, row, statusColor, createdDate, region, testName }) {

  let completionDate = null
  let score = null
  let cefrScore = null
  let typingWpm = null
  if (completion) {
    completionDate = new Date(completion.seconds * 1000);

    score = row.calculated_percentage;
    cefrScore = row?.cefr_score_recruiter? row?.cefr_score_recruiter: row?.cefr_score;
    typingWpm = row?.typing_wpm ?? null;
  }

  // Format test name for display: "customer_service" → "Customer Service"
  const formatTestName = (name) => {
    if (!name) return '';
    return name.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  };

  return (

    <Card sx={{boxShadow: "none !important"}}>
      <SoftBox
        component="li"
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        borderRadius="lg"
        px={2}
        mb={1}
        mt={1}
      >
        <SoftBox width="100%" display="flex" flexDirection="column">
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", sm: "center" }}
            flexDirection={{ xs: "column", sm: "row" }}
            mb={0.5}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
              fontSize="1rem"
            >
              {name}
            </SoftTypography>

          <SoftBox
            display="flex"
            alignItems="center"
            mt={{ xs: 1, sm: 0 }}
          >
            {showCodeGenerated ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <SoftTypography
                  variant="h7"
                  fontWeight="medium"
                  style={{ color: 'rgba(22, 48, 115, 1)', backgroundColor: 'rgba(238, 240, 253, 1)', borderRadius: '20px', fontWeight: '600', fontSize: '16px', padding: '6px 20px' }}
                >
                  {status}
                </SoftTypography>
                {(region || testName) && (
                  <SoftTypography
                    variant="caption"
                    style={{
                      color: '#8392AB',
                      fontSize: '12px',
                      fontWeight: '500',
                      marginTop: '4px',
                      paddingRight: '10px',
                    }}
                  >
                    {[region, formatTestName(testName)].filter(Boolean).join(' · ')}
                  </SoftTypography>
                )}
              </div>
            ) : (
          //   <SoftTypography
          //   variant="h7_bold"
          //   fontWeight="600"
          //   style={{ color: statusColor }} // Apply color here
          //   >
          //   {status}
          // </SoftTypography>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {(score || cefrScore) && !isNaN(score) && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'rgba(238, 240, 253, 1)',
                    borderRadius: '20px',
                    padding: '6px 10px',
                  }}
                >
                  <SoftTypography
                    variant="h7"
                    fontWeight="medium"
                    style={{
                      color: 'rgba(22, 48, 115, 1)',
                      fontWeight: '600',
                      fontSize: '16px',
                      marginLeft: '8px',
                    }}
                  >
                    {`CEFR: ${cefrScore ?? '--'} | Score: ${score != null ? score + ' %' : '-'}`}
                  </SoftTypography>
                </div>
              )}
              {typingWpm != null && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'rgba(238, 240, 253, 1)',
                    borderRadius: '20px',
                    padding: '6px 10px',
                    marginLeft: '8px',
                  }}
                >
                  <SoftTypography
                    variant="h7"
                    fontWeight="medium"
                    style={{
                      color: 'rgba(22, 48, 115, 1)',
                      fontWeight: '600',
                      fontSize: '14px',
                      marginLeft: '8px',
                    }}
                  >
                    {`Typing: ${typingWpm} WPM`}
                  </SoftTypography>
                </div>
              )}
            </div>
            {(region || testName) && (
              <SoftTypography
                variant="caption"
                style={{
                  color: '#8392AB',
                  fontSize: '12px',
                  fontWeight: '500',
                  marginTop: '4px',
                  paddingRight: '10px',
                }}
              >
                {[region, formatTestName(testName)].filter(Boolean).join(' · ')}
              </SoftTypography>
            )}
          </div>
          )}
        </SoftBox>
          </SoftBox>
          <SoftBox mb={0.25} lineHeight={0} style={{marginTop: '15px'}}>
            <SoftTypography variant="h7" color="text" style={{paddingRight: '15px'}}>
              <img
                src={MAIL}
                alt="Profile"
                width="24"
                height="24"
                style={{marginRight: '7px'}}
              />
              <SoftTypography variant="h7" style={{ fontSize: '16px', fontWeight: '400', verticalAlign: 'top' }}>
                {email}
              </SoftTypography>
            </SoftTypography>
            <SoftTypography variant="h7" color="text" style={{paddingRight: '15px'}}>
              <img
                src={PHONECALL}
                alt="Profile"
                width="24"
                height="24"
                style={{marginRight: '7px'}}
              />
              <SoftTypography variant="h7" style={{ fontSize: '16px', fontWeight: '400', verticalAlign: 'top' }}>
                {phone}
              </SoftTypography>
            </SoftTypography>
            {completionDate && (
              <SoftTypography variant="h7" color="text" style={{paddingRight: '15px'}}>
                <img
                  src={CALENDAR}
                  alt="Profile"
                  width="24"
                  height="24"
                  style={{marginRight: '7px'}}
                />
                <SoftTypography variant="h7" style={{ fontSize: '16px', fontWeight: '400', verticalAlign: 'top' }}>
                  {completionDate.toLocaleDateString("en-US", {
                    month: "2-digit",
                    day: "2-digit",
                    year: "2-digit",
                  })}
                </SoftTypography>
              </SoftTypography>
            )}
          </SoftBox>
          
          {/* <SoftBox style={{ display: 'flex', justifyContent: 'space-between' }}> */}
            {/* {completionDate && (
              <div style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
                <QuizIcon />
                <SoftTypography variant="h7" fontWeight="medium" style={{ fontWeight: '500', marginLeft: '8px' }}>
                  {completionDate.toLocaleDateString("en-US", {
                    month: "2-digit",
                    day: "2-digit",
                    year: "2-digit",
                  })}
                </SoftTypography>
              </div>
            )} */}
            {/* {score && !isNaN(score) && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <QuestionAnswerIcon />
                <SoftTypography variant="h7" fontWeight="medium" style={{ fontWeight: '500', marginLeft: '8px' }}>
                  {score} %
                </SoftTypography>
              </div>
            )} */}
          {/* </SoftBox> */}


        </SoftBox>
      </SoftBox>
    </Card>
  );
}

// Setting default values for the props of Bill
Bill.defaultProps = {
  noGutter: false,
};

// Typechecking props for the Bill
Bill.propTypes = {
  name: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  vat: PropTypes.string.isRequired,
  noGutter: PropTypes.bool,
};

export default Bill;
